import { render, staticRenderFns } from "./ParentRegisterStatusReport.vue?vue&type=template&id=249a633a&scoped=true"
import script from "./ParentRegisterStatusReport.vue?vue&type=script&lang=js"
export * from "./ParentRegisterStatusReport.vue?vue&type=script&lang=js"
import style0 from "./ParentRegisterStatusReport.vue?vue&type=style&index=0&id=249a633a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a633a",
  null
  
)

export default component.exports